import React from 'react';
import ServiceClient from '../CompanyForm';
import SiteForm from '../Organization/SiteForm';
import CorporateForm from '../CorporateForm';
import AddCompanyForm from '../AddCompanyForm';

function RenderForm({orgType, siteTableData, handleDirty, organizationAccess, edit}) {
  if (orgType === 'service-client') {
    return (
      <ServiceClient
        edit={edit}
        siteTableData={siteTableData}
        handleDirty={handleDirty}
        organizationAccess={organizationAccess}
      />
    );
  } else if (orgType === 'site') {
    return (
      <SiteForm
        edit={edit}
        siteTableData={siteTableData}
        handleDirty={handleDirty}
        organizationAccess={organizationAccess}
      />
    );
  } else if (orgType === 'corporate') {
    return (
      <CorporateForm
        edit={edit}
        siteTableData={siteTableData}
        handleDirty={handleDirty}
        organizationAccess={organizationAccess}
      />
    );
  } else if (orgType === 'company') {
    return (
      <AddCompanyForm
        edit={edit}
        siteTableData={siteTableData}
        handleDirty={handleDirty}
        organizationAccess={organizationAccess}
      />
    );
  } else {
    return (
      <ServiceClient
        siteTableData={siteTableData}
        handleDirty={handleDirty}
        organizationAccess={organizationAccess}
      />
    );
  }
}

export default RenderForm;
